import { UpdateReturnStatusReq } from "./types";

export const createRequest = (selectedState: string, storeCode: string,customerId:number, returnId:number): UpdateReturnStatusReq => {
    return {
        status: Number(selectedState), 
        storeCode: storeCode,
        returnId: returnId,
        customerId:customerId
    };
};